import React, { FC } from 'react';
import { Label, TextInput, Validation, ValidationStatus } from '@silverfort/sf-components';

interface Props {
    label: string;
    mandatory?: boolean;
    labelClassName?: string;
    value: string;
    onChange: (newValue: string) => void;
    placeholder?: string;
    containerClassName?: string;
    isSecret?: boolean;
    disabled?: boolean;
    errorMessage?: string;
}

const TokenTextField: FC<Props> = ({
    label,
    mandatory = true,
    labelClassName = 'w-[235px]',
    value,
    onChange,
    placeholder = 'Enter key',
    containerClassName = '',
    isSecret = false,
    disabled = false,
    errorMessage
}) => {
    return (
        <div className={`flex items-center gap-2 ${containerClassName}`}>
            <Label text={label} mandatory={mandatory} className={labelClassName} />
            <div className={`flex flex-col h-10`}>
                <TextInput
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    className="relative w-[344px]"
                    disabled={disabled}
                    isPassword={isSecret}
                />
                {errorMessage && (
                    <Validation showIcon={false} text={errorMessage} validationStatus={ValidationStatus.Error} />
                )}
            </div>
        </div>
    );
};

export default TokenTextField;
